export const isOnePageCheckoutEnabled = (setting, view, onepage, abOnepageTest = false) => {
    const treatment = onepage === '1' || onepage === '2' || abOnepageTest;
    switch (setting) {
        case 'mobile':
            return view === 'mobile';
        case 'desktop':
            return view === 'desktop';
        case 'both':
            return true;
        case 'ab_mobile':
            return treatment && view === 'mobile';
        case 'ab_desktop':
            return treatment && view === 'desktop';
        case 'ab_both':
            return treatment;
        default:
            return false;
    }
};
export const canStartOnePageCheckout = (setting, variantCode, view, onepage, abOnepageTest = false) => Boolean(variantCode) && isOnePageCheckoutEnabled(setting, view, onepage, abOnepageTest);
